import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";

import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";

import Typography from "@material-ui/core/Typography";
import FullBio from "./FullBio";

const useStyles = makeStyles({
  root: {
    display: "flex",
    maxWidth: 500,
  },
  media: {
    height: 140,
  },
  actionArea: {},
});

const PersonelCard = (props) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <Card className={classes.root}>
      <CardActionArea className={classes.actionArea} onClick={handleOpen}>
        <CardMedia className={classes.media} title="Contemplative Reptile" />
        {props.children}
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {props.data.name}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            <b>{props.data.title}</b>
          </Typography>
        </CardContent>
      </CardActionArea>
      <FullBio open={open} handleClose={handleClose} bio={props.data} />
    </Card>
  );
};

export default PersonelCard;
